import ElementUI from 'element-ui';
import { isVNode } from 'element-ui/src/utils/vdom';
let maxMessage = 1 //最多的显示消息数量
let messageQueue = [] //消息队列
let autoClose = false
function messageClose(temp) {
    // 如果是自动关闭不是手动点击关闭的，则跳过以下操作
    if (autoClose) {
        autoClose = false;
        return;
    }
    messageQueue.splice(temp.index, 1);
}
export default {
    install: (Vue) => {
        const originMessageConstructor = ElementUI.Message
        ElementUI.Message = function (options) {
            // 当前消息实例已经达到自定义上限，则关闭上一个
            if (messageQueue.length === maxMessage) {
                autoClose = true;
                messageQueue[0]?.instance?.close();
                messageQueue.shift();
            }
            let temp = {
                index: messageQueue.length,
                instance: undefined
            };
            let newOptions = {}
            if (typeof options === 'string' || isVNode(options)) {
                newOptions = {
                    message: options,
                    offset: 76,
                    duration: 1500,
                    showClose: true,
                    onClose: () => {
                        messageClose(temp);
                    }
                };
            } else {
                newOptions = {
                    offset: 76,
                    duration: 1500,
                    showClose: true,
                    ...options,
                    onClose: () => {
                        messageClose(temp);
                        if (options.onClose) {
                            try {
                                options.onClose()
                            } catch (error) {
                                console.log(error);
                            }
                        }
                    }
                };
            }
            const newMessage = originMessageConstructor(newOptions);
            temp.instance = newMessage;
            messageQueue.push(temp);
            return newMessage
        };
        let typeArray = ['success', 'warning', 'info', 'error']
        typeArray.forEach(type => {
            ElementUI.Message[type] = options => {
                let newOptions = {}
                if (typeof options === 'string' || isVNode(options)) {
                    newOptions = {
                        message: options,
                        offset: 76,
                        duration: 1500,
                        showClose: true
                    };
                } else {
                    newOptions = { offset: 76, duration: 1500, showClose: true, ...options };
                }
                newOptions.type = type;
                return ElementUI.Message(newOptions);
            };
        });
        ElementUI.Message.close = originMessageConstructor.close
        ElementUI.Message.closeAll = originMessageConstructor.closeAll
        Vue.prototype.$message = ElementUI.Message;
    }
};
